import React from "react";
import classNames from "classnames";

import style from "./Container.scss";

export const Container = ({ children, ...props }) => {
  const { className, ...otherProps } = props;
  const newClassName = classNames(className, style.container);

  return (
    <div className={style.containerWrapper}>
      <div className={newClassName} {...otherProps}>
        {children}
      </div>
    </div>
  );
};
